import { OnInit, Component } from "@angular/core";

@Component({
  selector: 'app-reimbursement-report',
  templateUrl: './reimbursement-report.component.html',
  styleUrls: ['./reimbursement-report.component.css']
})
export class ReimbursementReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}